import * as React from "react";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Static2}   from "@Common/react/static-2";
import {chain}     from "@Common/utils/fs";
import {keepOnly}  from "@Common/utils/objects";

import {fillColors1}     from "../draw-img/fill-colors-1";
import {getImgDataIndex} from "../draw-img/get-img-data-index";

import {absContrastColor} from "./abs-contrast-color";
import {addVector}        from "./add-vector";
import {eachPos}          from "./each-pos";
import {multiplyVector}   from "./multiply-vector";
import {pointsToRect}     from "./points-to-rect";
import {Repeating}        from "@Common/react/repeating";
import {rotatePoint}      from "./rotate-point";
import {subtractVector}   from "./subtract-vector";
import {toCssPos}         from "./to-css-pos";

/**
 * Rotation 0 -> going right, down
 */
export const BgCanvas = ({start, rotation, height, width, shouldShowColor=undefined, getBgColor, ratio,}) => cs(
    ["ref", (_, next) => Static2({next})],
    ({ref}) => {
        // console.log({start, rotation, height, width})
        const p2 = chain(
            {x: width, y:height},
            (_) => rotatePoint(_, rotation),
        );

        let rect = pointsToRect(start, addVector(p2, start));
        if (!rect.width || !rect.height) {
            return null;
        }

        return fragments(
            <canvas {...{
                className: "bg-canvas",
                ...keepOnly(rect, ["width", "height"]),

                style: {
                    imageRendering: "pixelated",
                    ...chain(
                        rect,
                        (_) => multiplyVector(_, ratio),
                        toCssPos,
                    ),

                    width : Math.max(1, rect.width  * ratio),
                    height: Math.max(1, rect.height * ratio),
                },

                ref: ref.set,
            }}/>,
            Repeating({
                watchValue: [start, width, height],
                action: () => {
                    const canvas = ref.get();

                    const ctx = canvas.getContext("2d", {willReadFrequently: true});
                    setpixelated(ctx);

                    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);

                    const p0 = chain(
                        pointsToRect({x:0,y:0}, p2),
                        (_) => multiplyVector(_, -1),
                    );

                    eachPos(imgData, (p) => {
                        // console.log("p", p);
                        const p1 = chain(
                            subtractVector(p, p0),
                            (_) => addVector(_, {x:.5,y:.5}),
                            (_) => rotatePoint(_, -rotation),
                            (_) => subtractVector(_, {x:.5,y:.5}),
                        );

                        if (!shouldShowColor || shouldShowColor(p1)) {
                            fillColors1(
                                chain(
                                    p,
                                    (_) => subtractVector(_, p0),
                                    (_) => addVector(_, start),
                                    getBgColor,
                                    absContrastColor,
                                ),
                                imgData.data,

                                getImgDataIndex(p, canvas.width),
                            )
                        }
                    });

                    ctx.putImageData(imgData, 0, 0);
                },
            }),
        );
    },
);

function setpixelated(context){
    context['imageSmoothingEnabled'] = false;       /* standard */
    context['mozImageSmoothingEnabled'] = false;    /* Firefox */
    context['oImageSmoothingEnabled'] = false;      /* Opera */
    context['webkitImageSmoothingEnabled'] = false; /* Safari */
    context['msImageSmoothingEnabled'] = false;     /* IE */
}

